<template>
  <SpecimenSurveyQueryTab :value="dataSource" />
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import SpecimenSurveyQueryTab from '@/components/MonitoringFeature/DataSources/SurveyEnvirodata/Tabs/SpecimenSurveyQueryTab'

  export default {
    components: {
      SpecimenSurveyQueryTab,
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      dataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.surveysEnvirodata)
        return data
      },
    },
  }
</script>